export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_FAILURE = "USER_FAILURE";
export const USER_SAVED_SUCCESS = "USER_SAVED_SUCCESS";
